import React, { type JSX } from 'react'
import { useDispatch } from 'react-redux'
import { HeaderStyled } from './FavouriteNumbers.styles'
import { FavouriteNumbersBetSummary } from './FavouriteNumbersBetSummary'
import { HeaderWithLoadingIndicator } from './HeaderWithLoader'
import { NumberSelection } from './NumberSelection'
import { PoolSelection } from './PoolSelection'
import { clearSelections } from './Store'

export const EasyBetTab = (): JSX.Element => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    return () => {
      dispatch(clearSelections())
    }
  }, [dispatch])

  return (
    <div data-testid='easy-bet' style={{ marginTop: '1em' }}>
      <HeaderWithLoadingIndicator title='SELECT NUMBERS' />
      <NumberSelection />
      <HeaderStyled>SELECT POOL DATES</HeaderStyled>
      <PoolSelection />
      <HeaderStyled>BET SUMMARY</HeaderStyled>
      <FavouriteNumbersBetSummary mode='easyBet' />
    </div>
  )
}
